import './embed.css';
import CreditApplicationFormV2 from '../credit-application-v2-form/credit-application-form-v2.container';
import { LeadSource } from '../../models/application.model';

export default function Embed() {
  return (
    <div id="embed">
      <CreditApplicationFormV2 leadSource={LeadSource.WEBSITE} />
    </div>
  );
}
